// Rendered when there are no results from the search query

import React from "react";
import PropTypes from "prop-types";

import logo from "images/logos/small-logo-and-wordmark.png";
import RequestContentModal from "components/shared/RequestContentModal";

const propTypes = {
  userSignedIn: PropTypes.bool
};

const defaultProps = {
  userSignedIn: false
};

const showRequestContentModal = () => {
  $("#request-content-modal").modal("show");
};

function NoResults(props) {
  return (
    <div className="no-results">
      <div className="no-results__title">No results found.</div>
      <div className="no-results__body text-center">
        Please try another search or{" "}
        {props.userSignedIn ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            href="#"
            data-amplitude="searchNoResultsRequestGuide"
            onClick={showRequestContentModal}
          >
            request a guide
          </a>
        ) : (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            href="#"
            data-amplitude="searchNoResultsRequestGuide"
            data-toggle="modal"
            data-target=".registration-modal"
          >
            request a guide
          </a>
        )}{" "}
        for us to cover.
      </div>
      <RequestContentModal
        logoUrl={logo}
        showAfterDelay={props.showRequestContentAfterDelay}
      />
    </div>
  );
}

NoResults.propTypes = propTypes;
NoResults.defaultProps = defaultProps;

export default NoResults;
